import { useCallback, useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import { getIsPointsPay } from 'store/ui/uiSelectors';
import { getTreatments } from 'store/split/splitSelectors';

const usePointsEarned = ({ pointsEarned: initialPointsEarned }) => {
  const isPointsPay = useSelector(getIsPointsPay);
  const splitTreatments = useSelector(getTreatments);
  const { propertyPpd, maxQffEarnPpd = 0, maxQbrEarnPpd = 0, qffPoints, qbrPoints } = initialPointsEarned;

  // assign to the minimal attributes we want to expose to prevent use of
  // attributes that won't be available after a recalculation
  const minimalPointsEarned = useMemo(
    () => ({
      qffPoints: {
        base: qffPoints.base,
        total: qffPoints.total,
      },
      qbrPoints: {
        total: qbrPoints.total,
      },
    }),
    [qbrPoints.total, qffPoints.base, qffPoints.total],
  );

  const [pointsEarned, setPointsEarned] = useState(minimalPointsEarned);

  const onCashPaymentAmountChange = useCallback(
    debounce(({ cashAmount }) => {
      if (splitTreatments.remove_earn_on_burn?.treatment === 'on') {
        setPointsEarned({
          qffPoints: {
            base: cashAmount.times(propertyPpd).toNumber(), //propertyPpd contains the default 'price per dollar' multiplier before any campaign is applied
            total: cashAmount.times(maxQffEarnPpd).toNumber(),
          },
          qbrPoints: {
            total: cashAmount.times(maxQbrEarnPpd).toNumber(),
          },
        });
      }
    }, 200),
    [maxQbrEarnPpd, maxQffEarnPpd],
  );

  useEffect(() => {
    if (!isPointsPay) {
      setPointsEarned(minimalPointsEarned);
    }
  }, [minimalPointsEarned, isPointsPay]);

  return { onCashPaymentAmountChange, pointsEarned };
};

export default usePointsEarned;
